import { makeAutoObservable } from 'mobx';

const LS_TOKEN  = 'mb4.accessToken';
const LS_CLIENT = 'mb4.activeClientId';

export default class UserStore {
    constructor() {
        this._isAuth = false;
        this._user = {};
        this._profile = null;
        this._role = 'guest';
        this._clients = [];                            // [{id, name, role_in_client}]
        this._activeClient = null;                     // {id, name, role_in_client}
        this._accessToken = localStorage.getItem(LS_TOKEN) || null;
        this._mustChangePassword = false;
        makeAutoObservable(this);
    }

    // ---- setters ----
    setIsAuth(bool)  { this._isAuth = bool; }
    setUser(u)       { this._user = u || {}; }
    setProfile(p)    { this._profile = p || null; }
    setRole(r)       { this._role = r; }
    setClients(arr)  {
        this._clients = Array.isArray(arr) ? arr : [];
        // если активный больше не в списке — сбросить
        if (this._activeClient && !this._clients.some(c => String(c.id) === String(this._activeClient.id))) {
            this.setActiveClient(this._clients[0] || null);
        } else if (!this._activeClient && this._clients.length === 1) {
            // авто-выбор при единственном клиенте
            this.setActiveClient(this._clients[0]);
        } else if (!this._activeClient && this._clients.length > 1) {
            // попробуем восстановить из localStorage
            const saved = localStorage.getItem(LS_CLIENT);
            const found = saved && this._clients.find(c => String(c.id) === String(saved));
            if (found) this.setActiveClient(found);
        }
    }
    setActiveClient(c) {
        this._activeClient = c || null;
        if (c?.id) localStorage.setItem(LS_CLIENT, String(c.id));
        else       localStorage.removeItem(LS_CLIENT);
    }
    setAccessToken(t) {
        this._accessToken = t || null;
        if (t) localStorage.setItem(LS_TOKEN, t);
        else   localStorage.removeItem(LS_TOKEN);
    }
    setMustChangePassword(b) { this._mustChangePassword = !!b; }

    /**
     * Загрузить состояние из ответа /v1/login или /v1/me
     */
    hydrateFromAuth({ accessToken, user, profile, clients, mustChangePassword }) {
        if (accessToken) this.setAccessToken(accessToken);
        if (user) {
            this.setUser(user);
            this.setRole(user.role);
        }
        if (profile !== undefined) this.setProfile(profile);
        this.setClients(clients || []);
        this.setMustChangePassword(mustChangePassword);
        this.setIsAuth(true);
    }

    logout() {
        this._isAuth = false;
        this._user = {};
        this._profile = null;
        this._role = 'guest';
        this._clients = [];
        this._activeClient = null;
        this._mustChangePassword = false;
        this.setAccessToken(null);
        localStorage.removeItem(LS_CLIENT);
        // подчищаем старые ключи на всякий случай
        ['isa','idu','idc','idr','remember'].forEach(k => localStorage.removeItem(k));
    }

    // ---- getters ----
    get isAuth()       { return this._isAuth; }
    get user()         { return this._user; }
    get profile()      { return this._profile; }
    get role()         { return this._role; }
    get clients()      { return this._clients; }
    get activeClient() { return this._activeClient; }
    get activeClientId() { return this._activeClient?.id || null; }
    get accessToken()  { return this._accessToken; }
    get mustChangePassword() { return this._mustChangePassword; }
    get isStaff()      { return [1, '1', 2, '2'].includes(this._role); }
}
